export default {
  'Edit': '編集',
  'Save': '保存',
  'Cancel': 'キャンセル',
  'Ok': 'はい',
  'and': 'また、',
  'Yes': 'はい',
  'No': 'いいえ',
  'Or': '又は',
  'Confirm': '確認',
  'Saved success': '保存成功',
  'Warning': '注意',
  'Cancel success': 'キャンセル成功',
  'Account binding failure': 'アカウント連動失敗',
  'UPDF Code verify': 'コード認証でUPDFにログイン',
  'UPDF Login': 'UPDFログイン',
  'UPDF Password login': 'UPDFパスワードログイン',
  'UPDF Forgot password': 'UPDFのパスワードパスワードを忘れた',
  'UPDF Reset password': 'UPDFのパスワードをリセット',
  'UPDF Set account info': 'UPDFアカウントの情報を設置',
  'UPDF Callback {loginType}': 'UPDFコールバック {loginType}',
  'UPDF Wechat login': 'UPDF Wechatログイン',
  'Welcome to': 'ようこそ',
  'Wechat': 'Wechat',
  'Click reload': 'リロード',
  'Log in by scanning QR code on Wechat<br>and following our official account': 'WechatでQRコードをスキャンし、公式アカウントにフォローする',
  'Email': 'メール',
  'Phone': '電話番号',
  'Unregistered account will be registered after entering the verification code': '認証コードを入力したら、未登録の電話番号、或はメールアドレスが自動的に登録されます',
  'Unregistered email will be registered after entering the verification code': '認証コードを入力後、メール本登録が完了します',
  'Or continue with:': 'または以下で続ける：',
  'By clicking continue, you accept our': '次をクリックすることで以下と同意することになります',
  'License Agreement': '規約',
  'Privacy Policy': 'プライバシーポリシー',
  'Enter your phone number or email...': '電話番号、メールアドレスを入力',
  'Enter your email address...': 'メールアドレスを入力',
  'Please enter a valid phone number or email': '有効な電話番号、メールアドレスを入力してください',
  'Please enter a valid email address': '有効なメールアドレスを入力してください',
  'Please enter your password': 'パスワードを入力してください',
  'Enter new password': '新しいパスワード入力してください',
  'The new password must be at least {min} characters.': '新しいパスワードは最低 {min} 文字必要です。',
  'The new password must be within {max} characters.': '新しいパスワードは{max}文字以内にしてください。',
  'Nickname must be within {max} characters.': 'ニックネームは{max}文字以下にしてください。',
  'Enter your password again': '新しいパスワードを再度入力してください',
  'Please enter your password again': '新しいパスワードを再度入力してください',
  'Those passwords didn\'t match. Try again.': 'パスワードが一致しませんでした。もう一度入力してください。',
  'Reset success,please log in use new password': 'リセット成功。新しいパスワードでログインしてください。',
  'Continue': '続ける',
  'Check mobile': '携帯電話を確認してください',
  'Check email': 'メールを確認してください',
  'Please enter the code sent to<br><span>{account}</span>': '<br><span>{account}</span>に送信されたコードを入力してください。このコードの有効期間は10分間です。',
  'If you do not receive the email, please check your spam or junk folder.': 'メールを受信できていない場合、迷惑フォルダをご確認ください。',
  'Resend': '再送',
  'seconds remaining to resend code': '再送までの秒数',
  'Verify Later': '後で認証',
  'Log in with password': 'パスワードログイン',
  'Log in with password-2': 'パスワードログイン',
  'Log in with code': '認証コードでログイン',
  'OR': '又は',
  'Back': '戻る',
  'Forgot password?': 'パスワードを忘れた場合',
  'Log in': 'ログイン',
  'Set password': 'パスワードを設置',
  'Reset your password': 'パスワードをリセット',
  'Add a photo': '画像を追加',
  'Your name': '名前',
  'What should we call you?': 'お名前を教えていただけますか？',
  'First name': '名前',
  'Last name': '名字',
  'Please enter first name': '名前を入力してください',
  'Please enter last name': '名字を入力してください',
  'Please enter your nickname': 'ニックネームを入力してください',
  'Set a password': 'パスワードをセットしてください',
  'Please enter new password': '新しいパスワードをセットしてください',
  'Set success': '設置完了',
  'Log in success': 'ログインしました',
  'Click "<span>Open UPDF</span>" in the above dialog box above to log into your account.': 'ダイアログボックス上の"<span>UPDFを開</span>"をクリックし、あなたのアカウントにログインしてください',
  'Can\'t see the dialog box? Click here.': 'UPDFを開く表示が出ませんか？ここをクリックしてください。',
  'Account center': 'アカウントセンター',
  'Account Center': 'アカウントセンター',
  'Account': 'アカウント管理',
  'Personal info': '個人情報',
  'Photo': 'アイコン',
  'Preferred name': '名前',
  'Email-2': 'メール',
  'UID': 'UID',
  'Mobile phone': '携帯電話番号',
  'Country': '国',
  'Linked Accounts Manage': '連動アカウントの管理',
  'Select country': '国を選択',
  'Your Plans of UPDF': 'あなたのUPDFのプラン',
  'Upgrade to UPDF Pro to get full access to all features without limits.': 'UPDF Proにアップグレードしてすべての機能にアクセス',
  'Subscriptions': '製品とプラン',
  'You can manage you plan in Apple ID settings': 'Apple ID設定にてサブスクリプションを管理できます',
  'Free': '無料',
  'Annual': '年間',
  'Monthly': '月間',
  'Quarterly': '四半期',
  'Perpetual': '永続',
  'Giveaway': 'プレゼントキャンペーン',
  'Cancel subscription': 'サブスクリプションをキャンセル',
  'Current Plan': '現在のプラン',
  'Renews': '更新',
  'Expire on': '有効期限',
  'VIP Duration': 'VIP期間',
  'Month': '月',
  'Months': '月',
  'Activate': '有効化',
  'Use Across Devices': '複数デバイスで利用可能',
  'As you already have a subscription plan, activating the "Giveaway" plan would make both plans run on your account, but it will not increase the original subscription time. Are you sure you want to activate the "Giveaway" plan?': 'すでにサブスクリプションプランをご利用中の場合、「ギブアウェイ」プランを有効化すると、両方のプランがアカウントで利用可能になります。ただし、元のサブスクリプションの期間は延長されません。「ギブアウェイ」プランを有効化してよろしいでしょうか？',
  'Activate the "Giveaway" plan': '「ギブアウェイ」プランを有効化する',
  'Password management': 'パスワード管理',
  'You can set password if you don\'t prefer logging in with codes.': 'パスワードをセットすることで、パスワードでログインすることができます。',
  'Change Password': 'パスワードを変更',
  'Set Password': 'パスワードを設置',
  'Are you sure log out your account?': '本当にログアウトしますか？',
  'Log out of UPDF account': 'UPDFアカウントからログアウト',
  'You may not be able to use all features after logging out of your account until you log back in.': '再度ログインするまで全機能が利用できなくなります。',
  'Log Out': 'ログアウト',
  'Confirm input error': '入力情報を確認してください',
  'Permanently delete your personal information and all data, this operation can\'t be recovered. Enter <span style="color: var(--el-color-primary)">{uid}</span> to confirm the operation.': 'すべての個人情報を削除する。一度削除すると戻りません。 <span style="color: var(--el-color-primary)">{uid}</span>を入力して確認してください。',
  'Delete your account': 'アカウントを削除',
  'Your personal information and all data will be removed permanently and can\'t be recovered.': 'すべてのアカウント情報は削除され、復元は不可能になります。',
  'Delete': '削除',
  'The avatar must be an image.': 'プロファイル画像は画像でなければなりません。',
  'You will miss the following membership rights when the subscription expired.': 'サブスクリプションが失効すると次の機能が利用できなくなります。',
  'Expire on {date}': '{date}より失効',
  'Redeem': '引き換え',
  'Redeem-2': '引き換え',
  'The license will be bound to your account, and extend the expiration date.': 'ライセンスはアカウントにバインドされ、有効期限が延長されます。',
  'Please input license.': '引き換えコードを入力してください',
  'Incorrect license code.': '無効な引き換えコードです',
  'Redeem success.': '引き換え成功',
  'Use across Windows, macOS, Android, iOS++No watermark++All annotate tools++Edit PDF text, images and links++Convert PDF to Word, Excel, PPT++OCR Text Recognition++Extract, insert, replace, split pages++Free updates and upgrades': 'Windows・macOS・iOS・Android間で使用可能++ウォーターマークなし++すべての注釈ツール++PDFのテキスト、リンク、画像を編集++PDFをワード、エクセル、パワポに変換++OCR文字認識++ページの整理、回転、抽出、挿入、分割++無料アップデート・アップグレード',
  'Keep UPDF Pro': 'UPDF Proを継続',
  'Continue Cancellation': '購読を停止',
  'Renew': '更新',
  'Activate Subscription': 'サブスクリプションを有効化',
  'Success! Your UPDF PRO subscription will be renewed on {date}': '成功！UPDF プロのサブスクリプションは{date} に更新されます',
  'Upgrade to Pro': 'Proにアップグレード',
  'Please enter the new mobile phone number': '新しい電話番号を入力してください',
  'Please enter a valid mobile phone number': '有効な電話番号を入力してください',
  'Please enter a new email address': '新しいメールアドレスを入力してください',
  'Please enter a valid email address-2': '有効な電話番号を入力してください',
  'Verification code error': '認証コードエラー',
  'Set': '設置',
  'Change': '変更',
  'Link': '連動',
  'Unlink': '連動を解除',
  'not set': '未設定',
  'not set-2': '未関連',
  'Phone Number': '電話番号',
  'Google': 'Google',
  'Apple ID': 'Apple ID',
  'Set Phone Number': '電話番号を設置',
  'Please enter the phone number and verification code.': '認証コードと電話番号を入力してください',
  'Set Email': 'メールを登録',
  'Please enter the email and verification code.': '認証コードとメールアドレスを入力してください',
  'Please enter the phone number': '電話番号を入力してください',
  'Please enter your email': 'メールアドレスを入力してください',
  'Verification code': '認証コード',
  'Send code': '認証コードを送信',
  'Resend-2': '再送',
  'please enter the verification code': '認証コードを入力してください',
  'Please use wechat to scan the QR code and follow the official account binding': 'WechatでQRコードをスキャンし、公式アカウントにフォローしてあなたのアカウントとリンクしてください',
  'To keep your account safe': 'アカウントを保護するため',
  'Please enter the verification code sent to': '送信された認証コードを入力してください',
  'Linked Accounts': '連動アカウント',
  'Binding success': '連動成功',
  'linked': '連動済み',
  'Unbind successfully': '連動を解除しました',
  'Unbinding failure': '連動の解除に失敗しました',
  'Are you sure you want to untie them': 'リンクを解除してよろしいでしょうか？',
  'UCloud Expires On': 'UPDF Cloudの有効期限',
  'UPDF Plan': 'UPDFプロ',
  'Full access to all UPDF features and UCloud benefits.': 'すべての UPDF 機能と UPDF Cloud をに完全にアクセスできます。',
  'Full access to all UPDF features and comes with 1-year UCloud benefits.': 'すべての UPDF 機能へのフルアクセスと1 年間のUPDF Cloud使用権',
  'Upgrade to UPDF Pro to get all UPDF features and UCloud benefits.': 'UPDF Proにアップグレードし、UPDFとUPDF Cloudのすべての機能を解放できます。',
  'Full access to all UPDF features.': 'すべての UPDF 機能へのフルアクセス。',
  'Create a Company': '会社を作成',
  'Please fill in the company information': '会社情報を記入してください',
  'Company Name': '会社名',
  'Industry Type': '産業名',
  'Number of Employees': '従業員数',
  'Set up enterprise account': 'エンタープライズアカウントをセットアップ',
  'Confirm your enterprise account. You will become the administrator with full management rights.': 'エンタープライズ アカウントを確認してください。 あなたが完全な管理権限を持つ管理者になります。',
  'Email Address': 'メールアドレス',
  'Email Address or Phone Number': 'メールアドレスまたは電話番号',
  'Please enter the password of {companyName}': '{companyName}のパスワードを入力してください',
  'Your company is created successfully.': '会社が作成されました',
  'Invite members to join the company by email or by copying the link.': 'メールまたはリンクをコピーして共有することで、メンバーを会社に招待してください。',
  'Invite members': 'メンバーを招待',
  'Invite Later': '後で招待',
  'Send Invitation': '招待を送信',
  'Copy Link': 'リンクをコピー',
  'UPDF PRO': 'UPDF PRO',
  'Your account now has full access to all features without limits.': 'あなたのアカウントは、すべての機能に無制限にアクセスできるようになりました。',
  'Your account has not been authorized by the administrator': 'あなたのアカウントは管理者によって承認されていません。',
  'All': 'すべて',
  'Authorized': '認証',
  'Unauthorized': '未認証',
  'Company Logo': '企業ロゴ',
  'Contact Information': '連絡情報',
  'Administrator': '管理者',
  'Email-1': 'メール',
  'Phone Number-1': '電話番号',
  'Transfer': '移行',
  'Permanently delete your company information and all data, this operation can not be recovered. Enter <span style="color: var(--el-color-primary)">{companyId}</span> to confirm the operation.': '会社情報とすべてのデータを完全で永遠に削除します。この操作は元に戻すことはできません。<span style="color: var(--el-color-primary)">{companyId}</span> を入力して確定してください。',
  'Assigned': '指定',
  'Quick Entry': 'クイックエントリー',
  'Last Login Time': '最近のログイン時間',
  'Operation': 'プロセス',
  'Search': '検索',
  'Link copied': 'リンクがコピーされました',
  'Email, separated by enter': 'メールを改行で差別してください',
  'This email is already on the list': 'メールはすでに登録されています',
  'Invalid Invite Code': '無効な招待コード',
  'You have joined the company.': '企業に参加しました',
  'The following accounts are bound to the current login method. Please select the account to log in.': '次のアカウントは、現在のログイン方法にリンクされています。 ログインするアカウントを選択してください。',
  'Enter password': 'パスワードを入力',
  'Please enter the password of <span>{username}</span>': '<span>{username}</span>のパスワードを入力してください',
  'This account is already logged in': 'このアカウントは既にログインされました',
  'You have successfully joined {companyName}': '{companyName}に参加できました',
  'Download UPDF now to share membership benefits': '今すぐ UPDF をダウンロードして、メンバシップの使用権益を共有しよう',
  'Download UPDF': 'UPDFをダウンロード',
  'Please Enter..': '..を入力してください',
  'Full Name': '名前',
  'Please login first': 'まずログインしてください',
  'administrator': '管理者',
  'Dissolve Company': '会社を解散',
  'Permanently delete your business information and data. This action is non-recoverable. Enter <span style="color: var(--el-color-primary)">{companyId}</span> to confirm.': '会社情報とデータを完全で永遠に削除します。 このアクションとデータは回復不能です。 {companyId} を入力して確認して下さい。',
  'Accommodation and Food Services': '宿泊・飲食サービス',
  'Administration, Business Support, and Waste Management Services': '管理、ビジネスサポート、および廃棄物管理サービス',
  'Agriculture, Forestry, Fishing, and Hunting': '農林漁業・狩猟',
  'Arts, Entertainment, and Recreation': '芸術、娯楽、レクリエーション',
  'Construction': '建設業',
  'Educational Services': '教育サービス',
  'Finance and Insurance': '金融と保険',
  'Healthcare and Social Assistance': '医療と社会支援',
  'Information and Communication': '情報・通信',
  'Manufacturing': '製造業',
  'Mining': '鉱業',
  'Other Services': '他のサービス',
  'Professional, Scientific, and Technical Services': '専門的、科学的、技術的サービス',
  'Real Estate, Rental, and Leasing': '不動産、賃貸、リース',
  'Wholesale and Retail Trade': '卸売および小売業',
  'Transportation and Warehousing': '輸送および倉庫保管',
  'Utilities': 'ユーティリティ',
  'Order No.': '注文番号',
  'Amount': '額',
  'Product': '製品',
  'Payment Time': '支払い時間',
  'Payment Status': '支払い状況',
  'Your order is being processed. It may take from 2 to 6 working days to process your payment using the payment method of Sofort/Pix/Boleto. You will be informed via email once the process is done.': 'ご注文は処理されています。 Sofort/Pix/Boleto の支払い方法を使用した支払いの処理には 2 ～ 6 営業日がかかる場合があります。 プロセスが完了すると、電子メールにて通知いたします。',
  'Unpaid': '未払い',
  'Failure': '失敗',
  'Paid': '有料',
  'Refunded': '返金済み',
  'Pending': '進行中',
  'Expire on:': '有効期限:',
  'Card Expired': 'カードの有効期限が切れました',
  'The payment card can only be changed for orders under subscription. For canceled orders, the renewal has been cancelled, and the payment card cannot be changed. If you need to change the payment card, please renew the subscription of this order in "Subscriptions" first.': '支払いカードは有効なサブスクリプション注文にのみ変更できます。キャンセルされた注文については、更新がキャンセルされており、支払いカードは変更できません。支払いカードを変更する必要がある場合は、まず「サブスクリプション」でこの注文を更新してください。',
  'Canceled': 'キャンセル済み',
  'Change Card': 'カードの変更',
  'Active': '有効化',
  'Inactive': '無効化',
  'Credit cards associated with subscription orders can be managed here. Here you can modify the credit card that will be used for future renewals. To cancel or restore a subscription, please operate in "Subscriptions".': 'サブスクリプション注文に関連付けられたクレジットカードはここで管理できます。今後の更新に使用するクレジットカードを変更することができます。サブスクリプションのキャンセルや復元は「サブスクリプション」から操作してください。',
  'Security': '安全',
  'Payment Management': 'お支払い管理',
  'Order Information': '注文情報',
  'Pay Again': 'もう一度支払う',
  'Change successfully': '変更成功',
  'Change failed, please try again': '変更失敗。もう一度お試しください',
  'Order information only includes orders purchased through the website. Applepay and Google Play orders will not be displayed.': '注文情報にはウェブサイトで購入された注文のみが含まれており、Applepay および Google Play での注文は表示されません。',
  'Membership': 'メンバーシップ',
  '(Educational)': '(教育)',
  'Issue an invoice': '請求書を発行',
  'Download invoice': '請求書のダウンロード',
  'Bill To:': '請求先：',
  'Name': '名前',
  'Address': '住所',
  'ZIP Code': '郵便番号',
  'Submit': '提出',
  'Please check the information carefully. It cannot be modified after submission. Are you sure to submit?': '情報をよくご確認ください。 提出後は修正できません。提出してもよろしいですか？',
  'Are you sure?': 'よろしいですか？',
  'Invoice Information': '請求書情報',
  'Must enter 1-20 characters': '1 ～ 20 文字を入力してください',
  'Must enter 1-100 characters': '1 ～ 100 文字を入力してください',
  'Must enter 1-500 characters': '1 ～ 500 文字を入力してください',
  'Must enter 1-200 characters': '1 ～ 200 文字を入力してください',
  'Must enter 1-50 characters': '1 ～ 50 文字を入力してください',
  'Device Management': '端末管理',
  'Desktop': 'デスクトップ',
  'Last active': '最後にログインした時',
  'Login out': 'ログインアウト',
  'Mobile': 'モバイル',
  'After being removed, the device will automatically log out and needs to be logged in again. Do you confirm the operation?': '削除後、デバイスは自動的にログアウトするため、再度ログインする必要があります。よろしいでしょうか？',
  'Settings': '設定',
  'Avatar': 'アイコン',
  'Sign Out': 'ログアウト',
  'Join Time': '加入時期',
  'Remove Member': 'メンバーを削除',
  'Deauthorize': '認証を取り消す',
  'Authorize': '認証',
  'Authorization': '認証',
  'Company Overview': '会社概要',
  'Redeem-3': '引き換え',
  'Buy Licenses': 'ライセンス購入',
  'Member Management': 'メンバー管理',
  'Deleted Successfully': '削除成功',
  'Deauthorized Successfully': '認証解除成功',
  'Authorized Successfully': '認証成功',
  'Redeemed successfully': '引き換え成功',
  'Company Settings': '会社設定',
  'Company Infomation': '会社情報',
  'The invitation has been sent successfully': '招待を送信できました',
  'Incorrect format of email': 'メールのフォーマットが正しくありません',
  'Incorrect format of phone number': '電話番号のフォーマットが正しくありません',
  'Dissolved successfully': '解散成功',
  'License View': 'ライセンスの表示',
  'Member View': 'メンバーの表示',
  'Total Licenses': '合計ライセンス数',
  'Total Members': '合計メンバー数',
  'Reset': 'リセット',
  'Number of Members': 'メンバー数',
  'Company ID': '企業ID',
  'No staff selected': 'メンバーを選択していません',
  'Please enter the email': 'メールアドレスを入力してください',
  'Add Member': 'メンバーを追加',
  'Please enter the company name': '会社名を入力してください',
  'Permanently delete your business information and data. This action is non-recoverable.': '会社情報とデータを完全で永遠に削除します。 このアクションは回復不能です。',
  'Skip': 'スキップ',
  'You are not an administrator and do not have permission to access this page.': 'あなたは管理者ではありません。このページにアクセスする権限を持っていません。',
  'Enterprise management': '企業管理',
  'Flexible configuration, tracking, and management of licenses within your company.': '社内のライセンスの柔軟な構成、追跡、および管理。',
  'Enterprise management dashboard': 'エンタープライズ管理ダッシュボード',
  'Authorization failed': '認証失敗',
  'Buy Now': '今すぐ購入',
  'Buy': '購入',
  'Insufficient licenses available! Want to buy more licenses?': '利用可能なライセンスが不十分です! 追加のライセンスを購入したいですか?',
  'Privilege grant failed': '権限の付与に失敗しました',
  'Number of Users': 'ユーザー数',
  'Member Avatar': 'メンバーアイコン',
  'Password must be 6-20 characters, and should have numbers, English letters, or symbols.': 'パスワードは 6 ～ 20 文字で、数字、英字、または記号を使用する必要があります。',
  'Not set': '未設定',
  'The current account is the administrator of {companyName}, please log in to the enterprise management platform and dissolve the company to complete the deletion.': '現在のアカウントは{companyName}の管理者です。エンタープライズ管理ダッシュボードにログインして会社を解散してください。',
  'Permanently and irreversibly delete the member\'s account and all data. Click OK to complete the deletion': 'メンバーのアカウントとデータを完全に削除します。このアクションは回復できません。[OK] をクリックして確定します。',
  'Got it': '完成',
  'CompanyId Error': '会社 ID エラー',
  'Select': '選択',
  'Enterprise management background': 'エンタープライズ管理ダッシュボード',
  'Authorized employees': '権限のある従業員',
  'Authorized members': '承認されたメンバー',
  'The current account already has a perpetual plan. If you need to redeem it again, please change to another account.': '当座預金口座にはすでに永久プランがあります。再度引き換える必要がある場合は、別のアカウントに変更してください。',
  'Number of redemption licences': '引き換えライセンスの数',
  'Invalid redemption code': '無効な引き換えコードです',
  'Allocation of Licence Quotas (Number of employees with licences/Total number of licences)': 'ライセンスクォータの割り当て（ライセンスを持つ従業員数/ライセンスの総数）',
  'Authorization of Employee Status (Number of employees with licences/Total number of employees)': '従業員資格認定（有資格者数/全従業員数）',
  'All the selected enterprise users will be permanently deleted. Do you want to continue?': '選択したすべてのエンタープライズ ユーザーが完全に削除されます。 続けたいですか？',
  'Share Invitation': '招待を共有',
  'Add Manually': '手動で追加',
  'Batch Import': 'バッチインポート',
  'Export All Member': 'すべてのメンバーをエクスポート',
  'Export Selected Member': '選択したメンバーをエクスポート',
  'Account: required. 6-60 characters. The account can not be repeated. It supports numbers, English letters and English symbols.': 'アカウント: この項目は必須です。6〜60文字で、重複できません。数字、英字、英字記号をサポートしています。',
  'Name: required. The length is limited to 60 characters.': 'お名前：必須長さは60文字に制限されています',
  'Password: optional. 6-20 characters. It supports numbers, English letters and English symbols.': 'パスワード: この項目は任意です。6〜20文字で、数字、英字、英字記号を含むことができます。',
  'Mobile phone number: optional. Phone number format.': '電話番号: この項目は任意です。電話番号の形式を入力してください。',
  'Whether to authorize: optional. Please fill in [Yes], [No]. If not filled, the default is [No].': '認証の有無: この項目は任意です。[Yes]、[No]で記入してください。記入しない場合はデフォルトで[No]となります。',
  'Uploaded Failed': 'アップロード失敗',
  'The content is wrong. Please modify and reupload.': '内容が間違っています。修正して再アップロードしてください。',
  'Uploaded Succeed!': 'アップロード成功',
  'Employee Table Template.xlsx': '社員表テンプレート.xlsx',
  'You can click to download the Employee table template and fill out the table': 'クリックして従業員表テンプレートをダウンロードし、表に記入することができます',
  'Copy the following information and notify the user to log in.': '次の情報をコピーし、ユーザーにログインするよう通知します。',
  'Must be letters, digits or symbols': '文字、数字、または記号でなければなりません',
  'Please contact administrator to reset password': '管理者に連絡してパスワードをリセットしてください',
  'Please enter account/email/phone number': 'アカウント/メール/電話番号を入力してください',
  'Please enter an effective account/email/phone number': '有効なアカウント/メール/電話番号を入力してください',
  'Please enter account/email': 'アカウント/メールアドレスを入力してください',
  'Please enter an effective account/email': '有効なアカウント/メールを入力してください',
  'Drag the template here, or <em>click to upload</em>': 'テンプレートをここにドラッグするか、<em>クリックしてアップロード</em>',
  'Account_1': 'アカウント',
  'Inactivated': '無効化完了',
  'Activated': '有効化完了',
  'Deleted': '削除済み',
  'Register & log in UPDF account You can convert <span>2 files for FREE</span>': 'UPDFアカウントに登録してログイン<span>2つのファイルを無料</span>に変換できます',
  'Register & log in UPDF account You can convert <span>2 files per day</span>for FREE': 'UPDF アカウントに登録してログインすると、<span>1 日あたり 2 ファイル</span>無料で変換できます',
  '{{.shareName}} added you to {{.companyName}}': '{{.shareName}}があなたを{{.companyName}}に追加しました',
  '{{.shareName}} added you to {{.companyName}}. You can share UPDF membership benefits now. The account information is as follows. Remember to save it and log in.': '{{.shareName}}があなたを{{.companyName}}に追加しました。今すぐUPDFメンバーシップ特典を共有できます。アカウント情報は以下の通りです。忘れずに保存してログインしてください。',
  'Password': 'パスワード',
  'Full name': 'フルネーム',
  'Your password has been reset': 'あなたのパスワードはリセットされました',
  'Your password has been reset by the administrator. The account information is as follows. Remember to save it and log in.': 'あなたのパスワードは管理者によってリセットされました。アカウント情報は以下の通りです。忘れずに保存してログインしてください。',
  'Upload the filled out template:': '記入済みのテンプレートをアップロードする',
  'Please enter account': 'アカウントを入力してください',
  'Please enter password': 'パスワードを入力してください',
  'Must enter 6-20 characters': '6～20文字を入力してください',
  'Please enter 1-30 characters': '1～30文字で入力してください',
  'Must enter 1-30 characters': '1～30文字を入力してください',
  'Please enter email': 'メールアドレスを入力してください',
  'Please enter an effective email': '有効なメールアドレスを入力してください',
  'Please enter phone number': '電話番号を入力してください',
  'Copy': 'コピー',
  'Only one file can be uploaded': 'アップロードできるファイルは 1 つだけです',
  'Accounts can not be repeated. Only numbers, letters, and symbols are supported; it is recommended to name accounts with numbers or letters plus a company suffix (for example: abc@updf, 0100@updf) to ensure uniqueness.': 'アカウント名は重複できません。数字、文字、記号のみがサポートされています。ユニーク性を確保するために、アカウント名には数字や文字に会社名のサフィックス（例：abc@updf、0100@updf）を追加することをお勧めします。',
  'Reason of failure:': '導入失敗の理由:',
  'Information copied': 'コピーされた情報',
  'Message sent': 'メッセージを送信しました',
  'The file can not exceed 10MB': 'ファイルは 10MB を超えることはできません',
  'Must enter 6-60 characters': '6～60文字を入力する必要があります',
  'The file exceeds the limit of 30,000 lines, please modify and upload again': 'ファイルが 30,000 行の制限を超えています。修正して再度アップロードしてください',
  'Support format': '対応形式',
  'Send a message to notify the user to log in': 'ユーザーにログインを通知するメッセージを送信する',
  'Please enter email/phone number': 'メールアドレス/電話番号を入力してください',
  'Please enter an effective email/phone number': '有効なメール/電話番号を入力してください',
  'Added successfully': '追加成功',
  'Member Info': 'メンバープロフィール',
  'Send': '送信',
  'The company name only supports Chinese characters': '企業名は漢字しか入力できない',
  'http_error_4023': 'これはエンタープライズライセンスコードです。エンタープライズ管理プラットフォームにアクセスして引き換えてください。',
  'E-mail: optional. Email format.': 'メールアドレス：任意。メール形式で入力してください。重複できません。',
  'Phone number: optional. Phone number format.': '電話番号：任意。電話番号形式で入力してください。重複できません。',
  'Enterprise name': '企業名',
  'Redeem Now': '今すぐ引き換え',
  'Auto-redemption': '自動償還',
  'You have purchased the Enterprise Plan. Do you want to auto-redeem your plan?': '企業プランを購入しました。 プランを自動引き換えしますか?',
  'Later': '後で',
  'Redemption code': '引き換えコード',
  'Users': 'ユーザー',
  'It is an enterprise license code, please go to Enterprise Management Dashboard to redeem it.': 'これはエンタープライズ 引き換えコードです。エンタープライズ管理ダッシュボードにアクセスして引き換えてください。',
  'Open UPDF': 'UPDFを開く',
  'Personal Account': '個人アカウント',
  'Enterprise Account': '企業アカウント',
  'Language Settings': '言語設定',
  'Language': '言語',
  'Click "Open UPDF" to automatically log in to the enterprise account.': '「UPDF を開く」をクリックすると、エンタープライズ アカウントに自動的にログインします。',
  'Click "Enterprise Management Dashboard", you can enter the Management Dashboard to redeem plan, set enterprise information, invite members to join the enterprise, and conduct enterprise management.': '「エンタープライズ管理ダッシュボード」をクリックすると、管理ダッシュボードに入り、プランの引き換え、企業情報の設定、企業へのメンバーの招待、企業管理を行うことができます。',
  'Company': '会社',
  'Please enter your purchased UPDF redemption code, the successful redemption will increase the number of authorized licenses for the company.': '購入した UPDF 引き換えコードを入力してください。引き換えが成功すると、会社に認可されたライセンスの数が増加します。',
  'Click to Accept': 'クリックして同意します',
  'Dissolve success': '解散成功',
  'Upload files up to 100 per month': '毎月最大 100 ファイルをアップロード',
  'Up to 1000 pages per file': '1ファイルあたり最大1000ページ',
  'Ask questions up to 1000 times per month': '1 か月あたり最大 1,000 回質問できます',
  'Up to 2GB per file': '1ファイルあたり最大2GB',
  '10GB of FREE ADDITIONAL STORAGE': '10GBの無料追加クラウドストレージ',
  'You have unlocked advanced AI features': '高度な AI 機能のロックを解除しました',
  'UPDF AI Pro Plan': 'AIアシスタント',
  'Upgrade': 'アップグレード',
  'Upgrade to UPDF AI Pro monthly Plan to unlock more AI features': 'AIアシスタントプランにアップグレードして、AI機能をもっと活用しよう。',
  'Full access to all UPDF AI features and UPDF Cloud benefits': 'すべてのAI アシスタント機能とUPDF Cloudのメリットへのフルアクセス',
  'Success! Your UPDF AI PRO subscription will be renewed on {date}': '完了。UPDF AI アシスタントのサブスクリプションは{date} に更新されます',
  'Keep UPDF AI Pro': 'AI アシスタントを継続',
  'Continue with Apple': 'Appleで続行',
  'Continue with Google': 'Googleで続行',
  'You can also <span>continue with SSO</span>': '<span>SSOで続行する</span>ことも可能です',
  'Operation successful': '操作成功',
  'Operation failed, please try again': '操作失敗。もう一度お試しください',
  'Super Admin information': 'スーパー管理者の情報',
  'Transfer super Admin': 'スーパー管理者の変更',
  'Confirm to transfer super Admin?': 'スーパー管理者の変更はよろしいですか？',
  'You will automatically log out of the management backend interface after the transfer': '変更後、管理バックエンド インターフェイスから自動的にログアウトします。',
  'Organization management': '組織管理',
  'Super Admin can add 5 ordinary Admin; ordinary Admin have all the operation rights of the management backend, except the following functions: transfer super Admin; add and remove ordinary Admins; dissolve the company.': 'スーパー管理者は 5 人の通常の管理者を追加できます。通常の管理者は、スーパー管理者の追加と削除、会社の解散を除き、管理バックエンドのすべての操作権限を持ちます。',
  'Add Admin': '管理者の追加',
  'Admin list': '管理者リスト',
  'Please enter the employee\'s account': '従業員のアカウントを入力してください',
  'Confirm to remove Admin?': '管理者を削除してよろしいでしょうか?',
  'After removal, the employee will not be able to enter the management backend': '削除後、従業員は管理バックエンドに入ることができなくなります',
  'Duplicate addition': '重複追加',
  'Super admin cannot be added as a normal admin': 'スーパー管理者を通常の管理者として追加することはできません',
  'The super admin removes you from the admin of {{.companyName}}. You can continue to use the enterprise account, but you no longer have the authority to manage the enterprise. If you have any questions, please communicate with the super admin in time.': 'スーパー管理者により、あなたは {{.companyName}} の管理者から削除されます。エンタープライズ アカウントを引き続き使用できますが、エンタープライズを管理する権限はなくなりました。ご質問がある場合は、スーパー管理者にお問い合わせください。時間。',
  'The super admin adds you as a admin of {{.companyName}}. You can log in to the enterprise management backend to manage the enterprise. The admin\'s account password is your UPDF enterprise account password.': 'スーパー管理者は、あなたを {{.companyName}} の管理者として追加します。エンタープライズ管理バックエンドにログインして、管理者のアカウントのパスワードは、UPDF エンタープライズ アカウントのパスワードです。',
  '{{.shareName}} transfers the super administrator of {{.companyName}} to you. You can log in to the enterprise management backend to manage the enterprise. The administrator\'s account password is your UPDF enterprise account password.': '{{.shareName}} は、{{.companyName}} のスーパー管理者をあなたに転送します。エンタープライズ管理バックエンドにログインして、エンタープライズを管理できます。管理者のアカウント パスワードは、UPDF エンタープライズ アカウントのパスワードです。',
  'Enterprise management dashboard:': 'エンタープライズ管理ダッシュボード:',
  'Notification of transferring enterprise super admin': '企業スーパー管理者の移行に関する通知',
  'Notification of adding enterprise admin': '企業管理者の追加に関する通知',
  'Notification of removing enterprise admin': '企業管理者の削除に関する通知',
  'Administrators cannot be deleted': '管理者は削除できません',
  'A maximum of 5 normal administrators can be added': '最大 5 人の通常の管理者を追加できます',
  'UPDF AI Unlimited': 'AIアシスタント',
  'UPDF AI Standard': 'AIアシスタント( 標準版)',
  'UPDF AI Plan': 'AIアシスタント',
  'Upload files unlimited per month++Up to 1000 pages per file++Ask questions unlimited times per month++Up to 2GB per file++100GB of FREE ADDITIONAL STORAGE': '1 か月あたり無制限のファイルアップロード++ 1 ファイルあたり最大 1,000 ページ++ 1 か月あたり無制限に質問可能++ 1 ファイルあたり最大 2 GB++100 GB の無料追加ストレージ',
  'Success! Your {aiType} subscription will be renewed on {date}': '成功！ {aiType} のサブスクリプションは {date} に更新されます',
  'Keep UPDF AI Unlimited': 'AIアシスタントを継続',
  'Keep UPDF AI Standard': 'AIアシスタント「標準版」を継続',
  'Organizational License View': 'エンタープライズライセンスダッシュボード',
  'Unlimited': '無制限',
  'Your company membership benefits will expire in {organizeExpiredTime} days and all membership benefits will be unavailable. Please contact UPDF sales promptly to renew your membership.': '会社のメンバーシップ特典は {organizeExpiredTime} 日後に期限切れとなり、すべてのメンバーシップ特典は利用できなくなります。 メンバーシップを更新するには、速やかに UPDF の営業にご連絡ください。',
  'Your company\'s membership rights have expired and all membership rights are no longer available. Please contact UPDF sales today to renew your membership.': 'あなたの会社のメンバーシップの権利は期限切れとなり、すべてのメンバーシップの権利は利用できなくなりました。 メンバーシップを更新するには、今すぐ UPDF セールスにお問い合わせください。',
  'Function Settings': '機能設定',
  'Enterprise cloud management': 'エンタープライズクラウド管理',
  'Enterprise AI management': 'エンタープライズ AI 管理',
  'Turn off': 'オフにする',
  'Trun on': 'オンにする',
  'When the function is turned on, employees can use the cloud function; when it is turned off, the cloud function is turned off and employee accounts can only use local files and cannot upload them to the cloud. This feature is enabled by default.': '機能をオンにすると、従業員はクラウド機能を利用できるようになります。 オフにすると、クラウド機能がオフになり、従業員アカウントはローカル ファイルのみを使用でき、クラウドにアップロードできなくなります。 この機能はデフォルトで有効になっています。',
  'After closing, all Cloud functions under the employee account will be closed, and all files uploaded to the Cloud will be inaccessible. Are you sure?': 'クラウド機能をオフにすると、従業員アカウントにあるすべてのクラウド機能が閉鎖され、クラウドにアップロードされたすべてのファイルにアクセスできなくなります。 よろしいですか？',
  'After closing, all Cloud functions under the employee account will be closed, and all files uploaded to the Cloud will be inaccessible. Since the AI function requires the Cloud to be turned on before it can be used, if you turn off the Cloud, the AI switch will be turned off at the same time. Are you sure?': 'クラウド機能をオフにすると、従業員アカウントにあるすべてのクラウド機能が閉鎖され、クラウドにアップロードされたすべてのファイルにアクセスできなくなります。 AI機能はクラウドをオンにする必要があるため、クラウドをオフにするとAIスイッチも同時にオフになります。 よろしいですか？',
  'Once enabled, all Cloud functions under the employee account will be enabled, and files can be uploaded to Cloud. Are you sure?': '有効にすると、従業員アカウントのすべてのクラウド機能が有効になり、ファイルをクラウドにアップロードできるようになります。 よろしいですか？',
  'When the function is turned on, employees can use AI; when it is turned off, the AI function is turned off. This function is a paid function. If you want to use AI, please contact sales': 'AIアシスタント機能をオンにすると、AIが利用可能になります。オフにすると、AIは使用できません。まだAIアシスタントプランを購入していない場合は、料金ページで購入したり、或は営業担当にお問い合わせください。',
  'After closing, all AI functions under the employee account will be closed, and all generated AI conversation content will be inaccessible. Are you sure?': '閉鎖後は、従業員アカウントのすべての AI 機能が閉鎖され、生成されたすべての AI 会話コンテンツにアクセスできなくなります。 よろしいですか？',
  'After it is enabled, all AI functions under the employee account will be enabled. Are you sure?': '有効にすると、従業員アカウントのすべての AI 機能が有効になります。 よろしいですか？',
  'This function is a paid function. If you want to use AI membership, please contact sales.': 'AIアシスタントをご利用いただくには、サブスクリプションが必要です。まだAIアシスタントプランをご購入されていない場合は、料金ページをご覧いただくか、営業チームまでお問い合わせください。',
  'Using the AI ​​function requires uploading documents to the Cloud. Please turn on the Cloud function first before turning on the AI ​​switch.': 'AI機能を使用するには、クラウドに文書をアップロードする必要があります。AI機能を起用する前に、クラウド機能をオンにしてください。',
  'I know': '完了',
  'Company User': 'ユーザー数',
  'Company UPDF Licenses': '企業 UPDF ライセンス',
  'Company AI Licenses': '企業 AI アシスタントライセンス',
  'UPDF': 'UPDF',
  'Use Of State': 'ライセンス状態',
  'Residue': '残余',
  'More Operations': '他のオプション',
  'Buy UPDF Licenses': 'UPDF プロライセンスの購入',
  'Buy AI Licenses': 'AI アシスタントライセンスの購入',
  'UPDF Authorize': 'UPDF プロ許可',
  'AI Authorize': 'AI アシスタント許可',
  'UPDF AI': 'AI アシスタント',
  'UPDF Deauthorize': 'UPDF プロ許可解除',
  'AI Deauthorize': 'AI アシスタント許可解除',
  'UPDF AI Authorize': 'AI アシスタント 許可',
  'Approval Management': '許可管理',
  'Order Number': '注文番号',
  'ProductUPDF': '製品',
  'Number': '番号',
  'Created at': '作成日時',
  'Payment Method': '支払い方法',
  'Money': '金額',
  'Subscription': 'サブスクリプション',
  'No Subscription': 'サブスクリプションなし',
  'UPDF Lifetime': 'UPDF 永遠プラン',
  'AI Annual': 'AI アシスタント年間プラン',
  'Non payment': '未払い',
  'payment failure': '支払い失敗',
  'cancel Subscribing': 'キャンセル サブスクリプション',
  'Subscribing': 'サブスクリプション',
  'Orders': '注文',
  'Create a personal account': '個人アカウントの作成',
  'CompanyAccount': 'アカウント',
  'Unauthorized employee': '未許可従業員',
  'Authorized employee': '許可済み従業員',
  'Order': '注文',
  'Amount of AI plans to be redeemed': '引き換える AI プランの数量',
  'Amount of UPDF plans to be redeemed': '引き換える UPDF プランの数量',
  'Pay time': '支払日時',
  'Quantity': '数量',
  'Payment status': '支払い状況',
  'Active Status': '有効状態',
  'Insufficient licenses available！Please contact sales.': '利用可能なライセンスが不足です。営業担当者にお問い合わせください。',
  'Please contact the administrator to obtain authorization so that you can use advanced features.': '高度な機能を使用できるようにするには、管理者に連絡して許可を獲得してください。',
  'Administrator Information': '管理者情報',
  'Transfer Administrator': '管理者変換',
  'Are you sure to transfer the administrator?': '管理者を変換してもよろしいですか?',
  'You will be automatically logged out of the Enterprise Management Dashboard after transfering the administrator. The new administrator can directly log in Management Dashboard through his account and password.': '管理者を変換すると、エンタープライズ管理ダッシュボードから自動的にログアウトされます。新しい管理者は、自分のアカウントとパスワードを使用して管理ダッシュボードに直接ログインできます。',
  'Account binding': 'アカウントリンク',
  'Please enter your email address and verification code': 'メールアドレスと確認コードを入力してください',
  'Please input your email': 'メールアドレスを入力してください',
  'Invalid verification code, please try again': '確認コードが無効です。もう一度お試しください。',
  'Current version': '現行版',
  'Check for upgrades': '更新確認',
  'The current version is already the latest version': '現在のバージョンはすでに最新バージョンです',
  'Upgrade immediately': 'すぐにアップグレードしてください',
  'Send verification code': '確認コードを送信する',
  'Account or password error': 'アカウントまたはパスワードのエラー',
  'Please contact the administrator to reset the password': '管理者に連絡してパスワードをリセットしてください',
  'Please enter the administrator\'s email': '管理者のメールアドレスを入力してください',
  'Please enter the 4-digit verification code sent to {account}. <br>Valid for 10 minutes.': '<br>{account}に送信された4桁の確認コードを入力してください。有効期限は10分間です。',
  'Private Enterprise Account': 'プライベートエンタープライズアカウント',
  'This software is about to be downloaded to the server, are you sure?': 'このソフトウェアをサーバーにダウンロードします。よろしいですか？',
  'The server will be upgraded, are you sure?': 'サーバーがアップグレードされますが、よろしいですか?',
  'Confirm Upgrade': 'アップグレードの確認',
  'Checking...': 'チェック中...',
  'Server Upgrade': 'サーバーのアップグレード',
  'Software Upgrade': 'ソフトウェアの更新',
  'The upgrade needs to be connected to the Internet, and the latest server configuration can be obtained': 'アップグレードにはインターネットに接続する必要があり、最新のサーバー構成を取得できます',
  'Operation failed. Please try again after the server is connected to the Internet': '操作失敗。サーバーがインターネットに接続された後、もう一度お試しください。',
  'Operation failed. Please try again after connecting to the local area network': '操作失敗。ローカルエリアネットワークに接続した後、もう一度お試しください。',
  'No permission. You are about to be automatically logged out': '権限がありません。まもなく自動的にログアウトされます。',
  'Insufficient license is available! Contact sales to buy more.': '使用可能なライセンスが不足です!価格ページをご覧いただき、営業チームにお問い合わせください。',
  'Your annual plan has {expireTime} days to expire, please contact sales to purchase perpetual plan.': '年間プランの有効期限が切れるまであと{expireTime}日です。永久プランを購入するには営業担当者にお問い合わせください。',
  'Password has been reset successfully. Please use the new password to log in.': 'パスワードが正常にリセットされました。新しいパスワードを使用してログインしてください。',
  'This email is used to reset the administrator password: when the administrator forgets the password, click "forgot password" on the login interface, and a verification code can be sent to this email to reset the password (the verification code needs to be connected to the Internet to receive it). When the administrator is transferred, the email will be changed accordingly, and the new administrator can also bind a new email.': 'この電子メールは、管理者パスワードをリセットするために使用されます。管理者がパスワードを忘れた場合、ログインインターフェイスで「パスワードを忘れた場合」をクリックすると、パスワードをリセットするための確認コードがこの電子メールに送信されます（確認コードは、インターネットで受信できます）。管理者が変更すると、それに応じて電子メールも変更され、新しい管理者は新しい電子メールを設定することもできます。',
  'Your version is already the latest version': 'あなたのバージョンはすでに最新バージョンです',
  'The upgrade needs to be connected to the Internet, and the latest software configuration can be obtained': 'アップグレードにはインターネットに接続する必要があり、最新のソフトウェア構成を取得できます',
  'Change binding': '関連設定変更',
  'Privatized Enterprise Account': 'プライベート企業アカウント',
  'Enterprise Management Dashboard': 'エンタープライズ管理ダッシュボード',
  'When upgrading, all client software will be suspended, please remind employees to save in time': 'アップグレードの際、すべてのクライアントソフトウェアが一時停止されますので、従業員に保存をお願いします。',
  'Upgrade failed, please try again': 'アップグレード失敗。もう一度お試しください',
  'http_error_4024': '引き換えコードは個人プランに関するものであり、企業では使用できません',
  'http_error_4408': 'ネットワーク接続がタイムアウトしました。インターネット接続が必要です',
  'This version includes bug fixes and performance improvements': 'このバージョンにはバグ修正とパフォーマンスの改善が含まれています',
  'UPDF Annual': 'UPDFプロ年間プラン',
  'Success! Your subscription will be renewed on {data}': '成功！サブスクリプションは {data} に更新されます。',
  'You will miss the membership rights when the subscription expired.': 'サブスクリプションの有効期限が切れると、メンバーシップの権利が失われます。',
  '⏰ <span>Expire on</span> {data}': '⏰ <span>有効期限</span> {data}',
  'Keep Subscribing': 'サブスクリプションを継続',
  'Active Subscription': 'サブスクリプションを有効化',
  'UPDF Sign Annually': 'UPDF Sign',
  'UPDF Sign Monthly': 'UPDF Sign',
  'Sign': 'UPDF Sign',
  'UPDF Sign': 'UPDF Sign',
  'Your account now has full access to all UPDF Sign features.': 'これで、あなたのアカウントはすべての UPDF Sign 機能に完全にアクセスできるようになりました。',
  'Full access to all UPDF Sign features and UPDF Cloud benefits.': 'すべての UPDF Sign 機能と UPDF Cloud の特典へのフルアクセス。',
  'UPDF Sign Authorize': 'UPDF Sign 許可',
  'Buy Sign Licenses': 'UPDF Signライセンスを購入する',
  'Amount of Sign plans to be redeemed': '引き換えられるサインプランの量',
  'Sign Authorize': 'UPDF Sign許可',
  'Sign Deauthorize': 'UPDF Signの許可解除',
  'Keep UPDF Sign': 'UPDF Signを継続',
  'Legally binding digital signature (certified by AATL).++Automatically notify recipients when signature is sent.++Multiple file signing and batch sending.++Save and manage digital signatures for long-term use.++Provides audit trail and certification.': '法的拘束力のあるデジタル署名 (AATL によって認証)。++署名が送信されると受信者に自動的に通知。++複数ファイルの署名とバッチ送信。++長期使用のためにデジタル署名を保存および管理。++監査証跡と証明書を提供。',
  '{number} signature requests per year.': '年間 {number} 件の署名リクエスト。',
  '{number} signature requests per month.': '毎月の署名リクエスト数は {number} 件です。',
  'Legally binding digital signature (certified by AATL).': '法的拘束力のあるデジタル署名 (AATL 認定)。',
  'Automatically notify recipients when signature is sent.': '署名が送信されると受信者に自動的に通知します。',
  'Multiple file signing and batch sending.': '複数のファイルの署名とバッチ送信。',
  'Save and manage digital signatures for long-term use.': '長期使用のためにデジタル署名を保存および管理します。',
  'Provides audit trail and certification.': '監査証跡と証明書を提供します。',
  '20GB cloud storage.': '20GBのクラウドストレージ。',
  '24*7 customer service support.': '24時間年中無休のカスタマーサービスサポート。',
  'Register & log in UPDF account You can convert <span>2 files per day</span> for FREE': 'UPDFアカウントを登録してログインしてください。<span>1日あたり2ファイル</span>を無料で変換できます。',
  'The annual membership signature quota is unlimited and cannot be modified after authorization to employees. Confirm the authorization?': 'UPDFサインの年間プランには、無制限の署名リクエストが含まれています。従業員に権限を付与すると、その権限を別の従業員に転送することはできません。権限付与を確認しますか？',
  'Authorized employees do not support cancellation. If you need to change, you can contact sales to modify it once.': '権限を付与された従業員はキャンセルできません。変更が必要な場合は、営業担当者に連絡して一度変更してもらうことができます。',
  'Usage of amount': '利用状況概要',
  'Total signature amount:': '総額：',
  'Expiration date:': '有効期限：',
  'Remaining amount:': '残額：',
  'Usage of Amount Detail': '利用明細：',
  'Amount Consumed': '使用済み額：',
  'Last Consumption Time': '最終利用日時：',
  'According to the billing process of relevant institutions, we will complete the billing for users every Wednesday': 'According to the billing process of relevant institutions, we will complete the billing for users every Wednesday',
  'If you need to create a personal account for use, click here': '個人アカウントを作成して使用する必要がある場合は、ここをクリックしてください',
  'Cancelled': 'キャンセル済み',
  'http_error_403': '許可なし',
  'http_error_408': 'タイムアウトしました。再度お試しください',
  'http_error_500': 'システムエラー。再度お試しください',
  'http_error_1401': '認証失敗。入力情報を確認してください',
  'http_error_2001': 'アカウントは既に存在しています',
  'http_error_2002': '無効な確認コードです。再度お試しください。',
  'http_error_2003': '認証コードの送信過多です。後ほど再度お試しください',
  'http_error_2004': '同一IPからログイン回数が多すぎます。後ほど再度お試しください',
  'http_error_2005': '５回以上パスワードを誤って入力しました',
  'http_error_2006': 'セッションの有効期限が切れました。再度ログインしてください。',
  'http_error_2007': 'ログインとログアウトを頻繁にしないでください。',
  'http_error_2008': 'セッション例外、再度ログインしてください',
  'http_error_2009': 'ログインしていません。ログインして下さい',
  'http_error_2012': 'アカウントが連動されています。アカウントを削除するか、連動を解除してから再度お試しください。',
  'http_error_2403': 'アカウント又はパスワードが間違います。',
  'http_error_2404': 'アカウントは存在しません',
  'http_error_2411': 'メール送信失敗！ もう一度お試しいただくか、メールアドレスをご確認ください。',
  'http_error_4004': '更新に対応していません',
  'http_error_4005': 'ライセンスが使用されました。',
  'http_error_4006': 'ライセンスはなくなりました',
  'http_error_4007': 'ライセンスはオフラインです',
  'http_error_4008': 'ライセンスは削除されました',
  'http_error_4009': 'ライセンスの期限が切れました',
  'http_error_4015': 'この商品にクーポンを使用できません',
  'http_error_4016': 'クーポンの使用回数が限度に達しました',
  'http_error_4019': '商品データが見つかりません。',
  'http_error_4020': 'クーポンが存在しません',
  'http_error_4021': '注文データが見つかりません。',
  'http_error_4022': 'プラン情報が見つかりません。',
  'http_error_4026': '引き換えたコードの有効期限が切れています。',
  'http_error_4027': 'クーポンが存在しません',
  'http_error_4028': 'すでに永久会員です。引き換え必要はありません。',
  'http_error_4014': 'アカウントが一致しませんでした',
  'http_error_4401': 'サーバーのトークンエラー',
  'http_error_4404': 'データが見つかりません。',
  'http_error_4502': 'タイムアウトしました。再度お試しください',
  'http_error_6004': '自分自身を削除することはできません',
  'http_error_6001': '自分を許可できません',
  'http_error_6002': '自分の許可を取り消すことはできません',
  'http_error_6003': '利用可能なライセンスが不足です',
  'http_error_6005': '招待コードの有効期限が切れています',
  'http_error_6506': 'エクスポートされたデータは空です',
  'http_error_6507': '輸入がまだ完了していません',
  'http_error_6508': '空白のインポートファイル',
  'http_error_6509': '無効なExcel形式',
  'http_error_6012': 'メールは既に存在しています',
  'http_error_6013': '電話番号は既に存在しています',
  'http_error_6006': '現在の企業アカウントは無効です',
  'http_error_2204': 'サブスクリプションが有効です。アカウントを削除する前にサブスクリプションをキャンセルしてください',
  'UPDF Account Center': 'UPDF アカウント センター',
  'Profile': 'プロフィール',
  'Products and Plans': '製品とプラン',
  'Payment and Order': '支払いと注文',
  'Account Settings': 'アカウント設定',
  'Account Types': 'アカウントの種類',
  'Save Changes': '変更を保存',
  'Newsletter Subscription Preferences': 'ニュースレターの購読設定',
  'Subscribe to our newsletter about news, offers and tips.': 'ニュース、オファー、ヒントに関するニュースレターを購読してください。',
  'Redeem License': 'ライセンスの引き換え',
  'You can manage the credit card for your subscription order here. Credit cards are stored by third-party payment institutions, and we at UPDF do not store any credit card information. If you need to unbind, please cancel your subscription in “Product and Plans” first.': 'ここで、サブスクリプション注文のクレジットカードを管理できます。クレジットカードはサードパーティの支払い機関によって保存され、UPDF ではクレジットカード情報を一切保存しません。解約する必要がある場合は、まず「製品とプラン」でサブスクリプションをキャンセルしてください。',
  'Order information only included orders purchased through rhe website. Apple Pay and Google Pay orders will not be displayed here.': '注文情報には、Web サイトから購入した注文のみが含まれます。Apple Pay および Google Google Pay の注文はここには表示されません。',
  'Card Details': 'カードの詳細',
  'Device Name': 'デバイス名',
  'Location': '場所',
  'Manage': '管理',
  'Linked Account': 'リンクされたアカウント',
  'Status': 'ステータス',
  'Actions': 'アクション',
  'No data': 'データがありません',
  'Log in with WeChat Scan': 'WeChatスキャンでログイン',
  'Log in with Account/Email/Phone Number': 'アカウント/メール/電話番号でログイン',
  'Registration is successful! Please fill in the following information': '登録が完了しました！以下の情報を入力してください',
  'Get Started': '開始',
  'Subscribe to our newsletter, Offers and Tips.': 'ニュースレター、オファー、ヒントを購読してください。',
  'Please verify you are human': '人間であることを確認してください',
  'Let us get to know you better': 'あなたのことをもっとよく知りたいです',
  'How do you plan to use UPDF?': 'UPDFをどのように利用する予定ですか？',
  'For personal use': '個人使用',
  'For work': '仕事用',
  'For my study or education work': '勉強や教育用',
  'How did you hear about us?': '弊社についてどのように知りましたか？',
  'Search (Google, Bing, etc.)': '検索（Google、Bingなど）',
  'Internet(newsletter, publication, blog etc.)': 'インターネット（ニュースレター、出版物、ブログなど）',
  'Internet ads': 'インターネット広告',
  'Youtube': 'Youtube',
  'Tiktok': 'TikTok',
  'Social media(Linkedin, Facebook, X, instagram etc.)': 'ソーシャルメディア（Linkedin、Facebook、X、Instagramなど）',
  'From a friend or colleague': '友人や同僚から',
  'Others(please specify)': 'その他（具体的に記入してください）',
  'Please specify': '具体的に記入してください',
  'What features do you plan to use with UPDF?': 'どのような機能を使用する予定ですか？',
  'AI': 'AI',
  'Edit PDF': 'PDF編集',
  'Annotate PDF': 'PDF注釈',
  'Convert PDF': 'PDF変換',
  'OCR': 'OCR',
  'Create, fill and sign PDFs': 'PDFの作成、記入、署名',
  'Organize PDF pages': 'PDFページの整理',
  'Redact and protect PDFs': 'PDFの編集と保護',
  'I don\'t know yet': 'まだわかりません',
  'What’s your age group?': 'ご年齢をお伺いしてもよろしいでしょうか？',
  'Under 18': '18歳未満',
  '18-24': '18-24',
  '25-34': '25-34',
  '35-44': '35-44',
  '45-54': '45-54',
  '55-64': '55-64',
  '65 and over': '65歳以上',
  'I prefer not to say': 'お答えは差し控えさせていただきます',
  'What kind of work do you do?': 'どのようなお仕事をされていらっしゃいますか？',
  'Select your role or job title': 'ご自身の役職や職務タイトルをお選びください。',
  '本科在读': '本科在读',
  '硕士在读': '硕士在读',
  '博士在读': '博士在读',
  '教师': '教师',
  'Education (students or education Staff)': '教育（学生または教育スタッフ）',
  'Healthcare': 'ヘルスケア',
  'IT': 'IT',
  'Finance': '金融',
  'Legal': '法律',
  'Creative industries': 'クリエイティブ産業',
  'Engineering': 'エンジニアリング',
  'Goverment and public service': '政府および公共サービス',
  'Non-profit and NGOs': '非営利団体およびNGO',
  'Media and entertainment': 'メディアおよびエンターテイメント',
  'Marketing and advertising': 'マーケティングおよび広告',
  'Energy and utilities': 'エネルギーおよび公共事業',
  'Manufacturing_1': '製造',
  'Real estate': '不動産',
  'Human resource': '人材',
  'Telecommunication': '通信',
  'Consulting': 'コンサルティング',
  'Building and construction': '建築・建設',
  'Retired': '退職者',
  'Others': 'その他',
  'Tell us a bit more': 'もう少し詳しく教えてください',
  'Next': '次へ',
  'Skip All': 'すべてスキップ',
  'Finish': '完了',
  'Registration is successful!': '登録が完了しました！',
  'Change Payment Method': '支払い方法の変更',
  'http_error_1400': '人間による認証に失敗しました。',
  'http_error_2400': 'メール認証に失敗しました。',
  'http_error_6011': 'アカウントが既に存在します',
  'Feedback': 'フィードバック',
  'Very Dissatisfied': '非常に不満',
  'Dissatisfied': '不満',
  'Neutral': 'どちらでもない',
  'Satisfied': '満足',
  'Very Satisfied': '非常に満足',
  'Attachment': '添付ファイル',
  'Is there anything we can help you with?': '何かお手伝いできることはございますか?',
  'Your email': 'メールアドレス',
  'Hello, we have received your feedback and will respond to you as soon as possible. Please be patient, and thank you for your understanding.': 'こんにちは。フィードバックをいただきました。できるだけ早くご返信いたします。しばらくお待ちください。ご理解のほどよろしくお願いいたします。',
  'Submission Failed': '送信に失敗しました',
  'Please correctly fill in your email address.': 'メールアドレスを正しく入力してください。',
  'Invalid email address, please re-enter.': 'メールアドレスが無効です。再入力してください。',
  'Please provide detailed feedback content.': 'フィードバックの内容を詳しくご記入ください。',
  'Unbind Card': 'カードのバインドを解除します',
  'Are you sure you want to unlink this credit card?': 'このクレジットカードのバインドを解除してもよろしいですか?',
  'Unbind': '解除',
  'Use email verification': 'メール認証を使用します',
  'Use phone verification': '携帯電話番号を使用して確認します',
  'Permanently delete your personal information and all data, this operation can’t be reconvered.': 'あなたの個人情報とすべてのデータは永久に削除され、回復することはできません。',
  'Please select one of the currently linked accounts to receive the verification code to proceed with your account deactivation.': '確認のためにバインドされたアカウントの1つを選択してください',
  'Other verification methods': 'その他の検証方法',
  'All devices that have permission to log in to this account will be displayed here. If you do not want a device to continue logging into the account, you can remove the device in time and <a href="#" class="change-pass">change the password</a>.': 'このアカウントにログインする権限を持つすべてのデバイスがここに表示されます。 デバイスによるアカウントへのログインを継続したくない場合は、適時にデバイスを削除し、パスワードを<a href="#" class="change-pass">変更できます</a>。',
  'All devices that have permission to log in to this account will be displayed here. If you do not want a device to continue logging into the account, you can remove the device in time.': 'このアカウントへのログインが許可されているすべてのデバイスがここに表示されます。アカウントにあるデバイスのログインを継続したくない場合は、デバイスを速やかに削除することができます。',
  '<span>{inviteNickName}</span> invites you to join <span>{companyName}</span> to share UPDF membership benefits.': '<span>{inviteNickName}</span>さんが<span>{companyName}</span>に招待しました。UPDFのメンバーシップ特典を共有しましょう。',
  'You’ve been invited': '招待されました',
  'Free Trial': '無料トライアル',
  'Accept now to access exclusive UPDF membership benefits.': '今すぐ承認して、UPDF メンバーシップの特典にアクセスしてください。',
  'Accept Invitation': '招待を承認する',
  'Welcome aboard! You’re all set.': 'ようこそ! 準備完了です。',
  'Download now to share membership benefits.': 'ダウンロードしてメンバーシップ特典を共有しましょう。',
  'Start Using UPDF': 'UPDFを使い始めます',
  'Account Details': 'アカウントの詳細',
  'After unsubscribing, you will no longer receive our email notifications, news, offers, and tips.': '登録を解除すると、ニュース、オファー、ヒントに関するメールが届かなくなります。',
  'You can manage the credit card for your subscription order here. Credit cards are stored by third-party payment institutions, and we at UPDF do not store any credit card information. If you need to unbind, please cancel your subscription in “Product & Plans” first.': 'ここでサブスクリプション注文用のクレジットカードを管理できます。クレジットカードは第三者の決済機関によって保存され、UPDFではクレジットカード情報を一切保存しません。解除が必要な場合は、「製品とプラン」でサブスクリプションをまずキャンセルしてください。',
  'Order information only included orders purchased through rhe website. Apple Pay and Google Google Pay orders will not be displayed here.': '注文情報には、UPDF のウェブサイトを通じて購入した注文のみが含まれます。Apple PayやGoogle Payの注文はここには表示されません。',
  'Work': '仕事',
  'Age': '年齢',
  'Please enter the code sent to<br><span>{account}</span>.': '<span>{account}</span> に送信されたコードを入力してください。',
  'The code is valid for 10 minutes.': 'コードの有効期間は 10 分です。',
  'SSO Log in': 'SSOログイン',
  'Upgrade AI Assistant to unlock more AI features': 'AI アシスタントをアップグレードして、より多くの AI 機能を利用できるようにします',
  'Profile Picture': 'プロフィール写真',
  'Account Deletion Confirmation': 'アカウント削除の確認',
  'Email/phone number': 'メール/電話番号',
  'Account/email/phone number': 'アカウント/メール/電話番号',
  'Account/email': 'アカウント/メール',
  'Get our desktop/mobile app': 'デスクトップ/モバイル アプリを入手',
  'Plan Types': 'プランの種類',
  'Details': '詳細',
  'Redeemable {isProduct} Membership Duration:': '引き換え可能な {isProduct} メンバーシップ期間:',
  'Tax Code': '税法',
  'http_error_4031': 'すでにプランをお持ちの場合は、再度購入する必要はありません',
  'Send code_2': 'コードを送信',
  'View Plans': 'プランを表示',
  'Add Credit Card': 'クレジットカードを追加',
  'Account Information': 'アカウント情報',
  'There are no orders. Would you like to upgrade your plan? <br>Please visit the pricing page to make a purchase.': '注文はありません。プランをアップグレードしますか? <br>購入するには、価格設定ページにアクセスしてください。',
  'Human-machine verification failed, <span>click to retry</span>': '人間と機械の検証に失敗しました。<span>再試行するにはクリックしてください</span>',
  'Subscribed Successfully': 'サインアップ成功',
  'Unsubscribe': 'サインアップを取り消す',
  'Upgrade to UPDF Sign Plan to unlock more Sign features': 'UPDF Sign メンバーシップにアップグレードすると、さらに多くの Sign 機能が利用できるようになります。',
  'Subscribe': 'サブスクリプション',
  'Please scan the QR code using WeChat': 'WeChatを使用してQRコードをスキャンしてください',
  'Enter your redemption code': '引き換えコードを入力してください',
  'Credit Card': 'クレジットカード',
}